<app-shop-header></app-shop-header>
<router-outlet></router-outlet>
<app-footer></app-footer>